export default __webpack_public_path__ + "static/media/60.3afb08b5.jpg";